<template>
    <div class="contato">
        <div class="container">

            <h1 class="display-1 mt-3">Dados do Sorteio</h1>
            <v-divider></v-divider>
            <v-flex class="mb-4">
                <p class="headline mt-4">{{concurso.descricao}}</p>
                <p class>
                    <span class="title">Período {{ concurso.inicio }} até {{ concurso.fim }}</span>
                </p>

                <p class="caption" style="color: orange">
                    De acordo com a legislação do município, pode haver limitação na quantidade
                    de bilhetes gerados para participação do sorteio.</p>
                <v-btn outlined small class="ml-2" color @click="acessaConcurso()">Retornar Concursos</v-btn>
            </v-flex>

            <h1 class="display-1 mt-3">Bilhetes - Quantidade: {{ bilhetes.length }}</h1>
            <v-divider></v-divider>
            <v-layout wrap class="my-3" style="display: flex">
                <v-flex class="d-flex flex-wrap">
                    <v-card v-for="bilhete in bilhetes" :key="bilhete" min-width="145" max-width="145" style="margin: 10px; background-color: lightgray">
                        <v-card-title>
                            {{ bilhete }}
                        </v-card-title>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs12 md6></v-flex>
            </v-layout>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            concurso: {},
            cpfCnpj: '',
            bilhetes: []
        }
    },
    created() {
        this.concurso = this.$route.params['concurso']
        this.cpfCnpj = this.$route.params['cpfCnpj']
        this.buscaBilhetes()
    },
    methods: {
        buscaBilhetes() {
            this.$httpNF(`bilhetes/${this.concurso.id}/${this.cpfCnpj}`).then(res => this.bilhetes = res.data)
        },
        acessaConcurso() {
            this.$router.push({name: 'Concurso', params: {'cpfCnpj': this.cpfCnpj}})
        }
    }
};
</script>

<style>
.form-link {
    text-decoration: none;
}
</style>


